"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndCard = void 0;
var EndCard = (function () {
    function EndCard(clientEndCard, apiEndCard) {
        var endCard = clientEndCard || apiEndCard;
        var supportedVideoTypes = (clientEndCard === null || clientEndCard === void 0 ? void 0 : clientEndCard.supportedVideoTypes) || (apiEndCard === null || apiEndCard === void 0 ? void 0 : apiEndCard.supportedVideoTypes);
        this.enabled = !!(endCard === null || endCard === void 0 ? void 0 : endCard.enabled);
        this.autoplay = !!(endCard === null || endCard === void 0 ? void 0 : endCard.autoplay);
        this.supportedVideoTypes = supportedVideoTypes || [];
    }
    return EndCard;
}());
exports.EndCard = EndCard;
